import { render, staticRenderFns } from "./Crud.vue?vue&type=template&id=2c8f1946&scoped=true"
import script from "./Crud.vue?vue&type=script&lang=js"
export * from "./Crud.vue?vue&type=script&lang=js"
import style0 from "./Crud.vue?vue&type=style&index=0&id=2c8f1946&prod&scoped=true&lang=css"
import style1 from "./Crud.vue?vue&type=style&index=1&id=2c8f1946&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8f1946",
  null
  
)

export default component.exports